var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg06WelcomeRewardPoints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66666 23.7627V16.028C2.66666 15.1187 3.29199 14.328 4.17732 14.1174L7.25066 13.3907C8.82132 13.0187 10.4707 13.164 11.9533 13.8027L17.792 16.32C19.644 17.1187 20.4787 19.284 19.64 21.1187L20.1373 21.7707L26.3413 19.556C27.5187 19.1187 28.824 19.744 29.2213 20.9347C29.5707 21.9827 29.096 23.128 28.108 23.6227L21.944 26.7267C20.716 27.34 19.2947 27.4414 17.992 27.008L9.80532 24.2787C8.63866 23.8894 7.37866 23.8867 6.20932 24.268L4.24666 24.9094C3.46799 25.164 2.66666 24.5827 2.66666 23.7627Z",
    fill: "#64CFF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 16C24.8758 16 26.6667 14.2091 26.6667 12C26.6667 9.79086 24.8758 8 22.6667 8C20.4575 8 18.6667 9.79086 18.6667 12C18.6667 14.2091 20.4575 16 22.6667 16Z",
    fill: "#64CFF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.6667 6.66667C23.4031 6.66667 24 6.06971 24 5.33333C24 4.59695 23.4031 4 22.6667 4C21.9303 4 21.3333 4.59695 21.3333 5.33333C21.3333 6.06971 21.9303 6.66667 22.6667 6.66667Z",
    fill: "#64CFF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.3333 10.6667C30.0697 10.6667 30.6667 10.0697 30.6667 9.33333C30.6667 8.59695 30.0697 8 29.3333 8C28.597 8 28 8.59695 28 9.33333C28 10.0697 28.597 10.6667 29.3333 10.6667Z",
    fill: "#64CFF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16 10.6667C16.7364 10.6667 17.3333 10.0697 17.3333 9.33333C17.3333 8.59695 16.7364 8 16 8C15.2636 8 14.6667 8.59695 14.6667 9.33333C14.6667 10.0697 15.2636 10.6667 16 10.6667Z",
    fill: "#64CFF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg06WelcomeRewardPoints);
export default __webpack_public_path__ + "static/media/06_welcome_reward_points.6fc7e62f4e9f92c751dc16beccc4d5ec.svg";
export { ForwardRef as ReactComponent };